import { useQuery } from '@tanstack/react-query'
import { getTrip } from '../../shared/api/trips'
import { tripKeys } from './useTrips'

export function useTrip(id: string | undefined) {
  return useQuery({
    queryKey: tripKeys.detail(id ?? 'unknown'),
    queryFn: () => getTrip(id as string),
    enabled: Boolean(id),
  })
}
